<template>
    <div>
        <div class="text-right media-list-type-toggle" v-if="allowModeToggle && files.length">
            <button class="btn btn-light btn-sm m-1" @click="displayMode = 'tiles'">
                <i class="fa fa-th-large fa-1x"
                   :class="displayMode === 'tiles' ? 'text-default' : 'text-muted'">
                </i>
            </button>
            <button class="btn btn-light btn-sm" @click="displayMode = 'list'">
                <i class="fa fa-list-ul fa-1x"
                   :class="displayMode === 'list' ? 'text-default' : 'text-muted'">
                </i>
            </button>
        </div>

        <div class="media-list-wrapper" :class="templateClass">
            <slot name="media-item" v-bind:data="{
                files,
                methods: {preview, download, remove}
            }">
                <media-item
                    v-for="file in files"
                    :key="file.serverUuid"
                    :file="file"
                    :on-click="onMediaClick"
                    :locale="locale"
                >
                    <template #actions>
                            <a
                                href="#"
                                @click.prevent="preview(file)"
                                v-if="file.isImage()"
                                class="btn btn-sm btn-light"
                            >
                                <i class="fa fa-eye" />
                            </a>

                            <a
                                href="#"
                                @click.prevent="download(file)"
                                class="btn btn-sm btn-light"
                            >
                                <i class="fa fa-download" />
                            </a>

                            <a
                                href="#"
                                @click.prevent="remove(file)"
                                class="btn btn-sm btn-light"
                                v-if="allowDelete"
                            >
                                <i class="fa fa-trash" />
                            </a>
                    </template>
                </media-item>
            </slot>
        </div>

        <cool-light-box
            :items="filesForLightbox"
            :index="lightBoxIndex"
            @close="lightBoxIndex = null"
        >
            <template slot="loading">
                <i
                    class="fa fa-spinner fa-spin"
                    style="color: #ccc; font-size: 3em"
                ></i>
            </template>
        </cool-light-box>
    </div>
</template>

<script>
import MediaItem from './MediaItem'
import {
    downloadFile,
    getImageUrl,
    getThumbnailUrl
} from '../../../repositories/defaultRepository'
import { streamFile } from '../../../services/helpers'
import CoolLightBox from 'vue-cool-lightbox'

export default {
    name: 'MediaList',
    components: {
        MediaItem,
        CoolLightBox
    },
    props: {
        files: {
            type: Array,
            default: () => []
        },
        allowDelete: {
            type: Boolean,
            default: false
        },
        allowModeToggle: {
            type: Boolean,
            default: false
        },
        defaultMode: {
            type: String,
            default: 'list',
            validator: (value) => ['list', 'tiles'].includes(value)
        },
        locale: String
    },
    mounted() {
        this.displayMode = this.defaultMode;
    },
    computed: {
        filesForLightbox() {
            return this.files
                .map(file =>
                    file.isImage()
                        ? {
                              src: getImageUrl(file.serverUuid),
                              thumb: getThumbnailUrl(file.serverUuid),
                              title: file.getTitle()
                          }
                        : null
                )
                .filter(Boolean)
        },
        templateClass() {
            if (this.displayMode === 'tiles') {
                return 'template-tiles';
            }
            return 'template-list'
        }
    },
    methods: {
        download(file) {
            file.isDownloading = true
            downloadFile(file.serverUuid).then(({ response }) => {
                file.isDownloading = false
                streamFile(response)
            })
        },
        preview(fileToPreview) {
            let index = 0
            for (let file of this.files) {
                if (file.serverUuid === fileToPreview.serverUuid) {
                    break
                }
                if (file.isImage()) {
                    index++
                }
            }
            this.lightBoxIndex = index
        },
        remove(file) {
            this.$emit('delete', file)
        },
        onMediaClick(file) {
            file.isImage() ? this.preview(file) : this.download(file)
        }
    },
    data: () => ({
        lightBoxIndex: null,
        displayMode: 'list'
    })
}
</script>

<style scoped></style>
